export default "__VITE_ASSET__BAsXP7gr__"